import { QueryKey } from '@/configs/queryKeys';
import { Attachment, ForeignLanguage } from '@/types/types';
import EntityApi, { BaseEntity } from './EntityApi';

export enum ContentType {
	TEXT = 'TEXT',
	IMAGE = 'IMAGE',
	ELEMENT = 'ELEMENT',
}

type ContentImage = Pick<Attachment, 'id' | 'path'>;

export interface Content extends BaseEntity {
	slug: string;
	type: ContentType;
	content: string;
	image?: ContentImage;
	translations: Partial<
		Record<
			ForeignLanguage,
			{
				content: string;
				image?: ContentImage;
			}
		>
	>;
}

class ContentApi extends EntityApi<Content> {
	constructor() {
		super(QueryKey.content);
	}
}

export default new ContentApi();
